import { checkedOutcomePoolQuoteContextFromSnapshot, outcomeSpotPriceD9 } from '@morfi/market-math';
import type { OnchainTradeData } from '@/queries/onchain-trade-data';

export interface OutcomeSpotPriceD9 {
  readonly outcomeIndex: number;
  readonly priceD9: string;
}

/** Derive lifecycle-correct D9 spot prices through the shared pool service. */
export function deriveOutcomeSpotPricesD9(
  tradeData: OnchainTradeData,
  stateStale: boolean = false,
): OutcomeSpotPriceD9[] {
  const outcomeByIndex = new Map<number, (typeof tradeData.outcomes)[number]>();
  for (const outcome of tradeData.outcomes) {
    if (!outcomeByIndex.has(outcome.outcomeIndex)) {
      outcomeByIndex.set(outcome.outcomeIndex, outcome);
    }
  }
  const prices: OutcomeSpotPriceD9[] = [];
  for (const [outcomeIndex, outcome] of outcomeByIndex) {
    if (outcome === undefined) continue;
    const checkedContext = checkedOutcomePoolQuoteContextFromSnapshot(
      tradeData,
      tradeData.market,
      outcomeIndex,
      outcome.outcomeMint,
      stateStale,
    );
    if (!checkedContext.available) continue;
    const price = outcomeSpotPriceD9(checkedContext.value.context);
    if (!price.available || price.value <= BigInt(0)) continue;
    prices.push({ outcomeIndex, priceD9: price.value.toString() });
  }
  return prices;
}
